import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';
import { inject } from '@angular/core';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) => {
            if (authenticated) {
                // router.navigate(['admin/perfiles']);
                // return of(false);
            }
            return of(true);
        }),
    );
};
